module.exports = __webpack_public_path__ + "static/img/HY-S2.7f8658cd.png";